import { TextArea } from "@package/subframe/components/TextArea";

interface Props {
  notes: string;
  onNotesChange: (notes: string) => void;
}

export function SimpleCompletionForm({ notes, onNotesChange }: Props) {
  return (
    <div className="flex w-full flex-col items-start gap-4">
      <div className="flex w-full flex-col items-start gap-2">
        <label className="text-body-bold font-body-bold text-neutral-900">
          Notes
        </label>
        <span className="text-caption font-caption text-subtext-color">
          Optional — anything worth recording about this completion.
        </span>
        <TextArea className="h-auto w-full" label="" helpText="">
          <TextArea.Input
            placeholder="e.g. Replaced batteries in unit 2"
            value={notes}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              onNotesChange(e.target.value)
            }
          />
        </TextArea>
      </div>
    </div>
  );
}
